import type { CustomRouteContext } from 'core/universalRouter/types';
import type { Store } from 'react-redux';
import { fetchTitleGenerationConfig } from 'store/ai/actions';
import { resetAITitleState } from 'store/ai/slice';
import { fetchSEOData } from 'store/seo/action';

import { fetchLoggedInUser } from 'store/authCode/actions';
import { fetchReviewFormConfig } from 'store/reviewConfig/actions';
import { REVIEW_POST_PAGE } from 'utils/ratHelper';

import type { RouteContext } from 'universal-router';
import { fetchMediaConfig } from 'store/media/actions';

export default async function postReviewResolver(
  context: RouteContext<CustomRouteContext>,
  store: Store,
): Promise<void> {
  const { query } = context;
  const { dispatch } = store;

  await Promise.all([
    dispatch(fetchReviewFormConfig(query)),
    dispatch(fetchLoggedInUser()),
    dispatch(fetchSEOData({ pageName: REVIEW_POST_PAGE })),
    dispatch(resetAITitleState()),
    dispatch(fetchTitleGenerationConfig()),
    dispatch(fetchMediaConfig()),
  ]);
}
